import React from "react";
import { Modal, Button } from "react-bootstrap";
import { BsPerson } from "react-icons/bs";

//Modal para audiencias finalizados

function ExpiredEventModal({ show, event, handleClose }) {
  if (!event) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      size="md"
      className="rounded-3"
    >
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "#1e2b37",
          color: "#fff",
          borderBottom: "none",
          padding: "15px 20px",
        }}
      >
        <Modal.Title style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
          {event.title}
          <div
            style={{
              fontSize: "1rem",
              fontWeight: "normal",
              marginTop: "0.2rem",
            }}
          >
            <BsPerson style={{ marginRight: "0.5rem" }} />
            Audiencia creada por {event.extendedProps.creado_por}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "20px", backgroundColor: "#f8f9fa" }}>
        <div style={{ fontSize: "1rem", lineHeight: "1.6", color: "#333" }}>
          <p
            style={{
              marginBottom: "15px",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            <strong style={{ color: "#2c3e50" }}>Empleado:</strong>{" "}
            <span style={{ color: "#555" }}>
              {event.extendedProps.empleado.nombre}
            </span>
          </p>
          {event.extendedProps.caso_disciplinario.id && (
            <p
              style={{
                marginBottom: "15px",
                borderBottom: "1px solid #ddd",
                paddingBottom: "10px",
              }}
            >
              <strong style={{ color: "#2c3e50" }}>
                Caso Disciplinario Asociado:
              </strong>{" "}
              <span style={{ color: "#555" }}>
                {event.extendedProps.caso_disciplinario.descripcion}
              </span>
            </p>
          )}
          <p
            style={{
              marginBottom: "15px",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            <strong style={{ color: "#2c3e50" }}>Jefe Inmediato:</strong>{" "}
            <span style={{ color: "#555" }}>
              {event.extendedProps.jefe_inmediato.nombre}
            </span>
          </p>
          <p
            style={{
              marginBottom: "15px",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            <strong style={{ color: "#2c3e50" }}>Fecha de Inicio:</strong>{" "}
            <span style={{ color: "#555" }}>
              {new Date(event.start).toLocaleString()}
            </span>
          </p>
          <p style={{ marginBottom: "15px" }}>
            <strong style={{ color: "#2c3e50" }}>Fecha de Fin:</strong>{" "}
            <span style={{ color: "#555" }}>
              {new Date(event.end).toLocaleString()}
            </span>
          </p>
          <p
            style={{
              marginBottom: "15px",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            <strong style={{ color: "#2c3e50" }}>Comentarios:</strong>{" "}
            <span style={{ color: "#555" }}>
              {event.extendedProps.comentarios}
            </span>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          padding: "15px 20px",
          backgroundColor: "#e9ecef",
          borderTop: "1px solid #ddd",
        }}
      >
        <Button
          className="rounded-pill"
          variant="primary"
          onClick={handleClose}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ExpiredEventModal;
